import { MenuLinkTypeEnum } from 'common/components/entities/Menu/enums/MenuLinkTypeEnum'

export const menuLinkTypeLocoKeys: Record<MenuLinkTypeEnum, string> = {
  [MenuLinkTypeEnum.link_type_custom_url]:
    'entity_settings.menu.item.link_type.custom_url',
  [MenuLinkTypeEnum.link_type_blog_page]:
    'entity_settings.menu.item.link_type.blog_page',
}
